module.exports = __webpack_public_path__ + "static/img/0758.527ee22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0758.jpg
// module id = 97
// module chunks = 0